module.exports = __webpack_public_path__ + "img/segments.3e97a5c7.svg";